import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ChaptersSection() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              最新冒险篇章
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl leading-relaxed">
              跟随好色精灵探访记，开启一段段精彩纷呈的色彩冒险之旅。每一篇章都是全新的奇幻体验。
            </p>
          </div>
          <Link
            to="/category/chise-jingling"
            className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer"
          >
            查看全部篇章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={`好色精灵探访记 - ${article.title}`}
                  title={`好色精灵探访记 ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                </div>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}